import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import FieldviewLoginPopup from '/@/components/fieldview-login-popup';
import Popup from '/@/components/popup';
import Terms from '/@/components/terms';
import { _ } from '/@/locale';
import { setShowTermsAndConditions } from '/@/store/nav/actions';
import { getShowTermsAndConditions } from '/@/store/nav/selectors';

const FieldListV2Modals = () => {
    const provider = new URLSearchParams(window.location.search).get('provider');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const showTermsAndConditions = useSelector((state) => getShowTermsAndConditions(state));

    return (
        <Box>
            {/* <CropMonitoringModal /> */}
            <Popup
                onClose={() => dispatch(setShowTermsAndConditions(false))}
                showCloseIcon
                visible={Boolean(showTermsAndConditions)}
            >
                <Terms />
            </Popup>

            {provider === 'fieldview' && (
                <FieldviewLoginPopup
                    handleClose={() => {
                        const url = new URL(window.location.href);
                        url.searchParams.delete('provider');
                        navigate(url.pathname + url.search + url.hash, { replace: true });
                    }}
                    message={_('¡Sincronizaste con Fieldview!')}
                />
            )}
        </Box>
    );
};

export default FieldListV2Modals;
